import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import BrandedLoading from '../BrandedLoading';
import MaabarWordmark from '../MaabarWordmark';
import { fetchIsGrowthOwner } from '../../lib/growthAccess';
import { fetchIntegrationStatus } from '../../lib/growthDashboard';
import { fetchPendingCount } from '../../lib/growthApprovals';
import { GROWTH_SECTIONS, growthPath } from '../../lib/growthSections';
import './growth.css';

const PATHS = {
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
  megaphone: 'M3 11v2a1 1 0 0 0 1 1h3l5 4V6L7 10H4a1 1 0 0 0-1 1zM16 8a5 5 0 0 1 0 8M19 5a9 9 0 0 1 0 14',
  route: 'M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM6 15V9a4 4 0 0 1 4-4h6M18 9v6a4 4 0 0 1-4 4H8',
  pointer: 'M4 4l7 17 2.5-7.5L21 11z',
  box: 'M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16zM3.3 7L12 12l8.7-5M12 22V12',
  flask: 'M9 3h6M10 3v6L4.5 18.5A1.7 1.7 0 0 0 6 21h12a1.7 1.7 0 0 0 1.5-2.5L14 9V3M7 15h10',
  coins: 'M12 7c4.4 0 8-1.3 8-3s-3.6-3-8-3-8 1.3-8 3 3.6 3 8 3zM4 4v6c0 1.7 3.6 3 8 3s8-1.3 8-3V4M4 10v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6',
  spark: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 16l.7 2.3L22 19l-2.3.7L19 22l-.7-2.3L16 19l2.3-.7z',
  check: 'M9 12l2 2 4-4M12 3l8 3.5V11c0 5-3.4 9.3-8 10.5C7.4 20.3 4 16 4 11V6.5z',
  doc: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5',
  plug: 'M9 2v6M15 2v6M6 8h12v4a6 6 0 0 1-12 0zM12 18v4',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  back: 'M9 18l6-6-6-6',
  menu: 'M3 6h18M3 12h18M3 18h18',
  list: 'M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  book: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5zM4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5',
  handshake: 'M3 12l4-4 4 2 3-2 4 1 3 3M3 12l5 5 2-1 2 2 2-1 2 1 5-6M11 10l3 3',
};
export const Icon = ({ name, size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
       strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }} aria-hidden="true">
    <path d={PATHS[name]} />
  </svg>
);

// Growth OS — its own full page, outside the admin console layout. Every
// Growth route renders through this shell, so every one of them passes the
// same server-side owner check (is_growth_owner()). Nothing of the page is
// rendered until the server says yes; a no goes back to the admin console.
//
// Built from divs with roles on purpose — see the warning in growth.css: the
// site's global stylesheet turns any <nav> into its fixed top bar.
export default function GrowthShell({ user, profile, lang, active, title, actions, children }) {
  const nav = useNavigate();
  const location = useLocation();
  const [owner, setOwner] = useState(null);
  const [drawer, setDrawer] = useState(false);
  const [integrations, setIntegrations] = useState(null);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    if (!user) return undefined;
    let alive = true;
    fetchIsGrowthOwner().then((ok) => {
      if (!alive) return;
      setOwner(ok);
      if (ok) fetchIntegrationStatus().then((r) => { if (alive) setIntegrations(r); });
      // proposals waiting for him (Phase B); a failed count shows no badge, never an error
      if (ok) fetchPendingCount().then((n) => { if (alive) setPending(n); }).catch(() => {});
    });
    return () => { alive = false; };
  }, [user]);

  useEffect(() => { setDrawer(false); }, [location.pathname]);

  if (user === undefined || (user && owner === null)) return <BrandedLoading lang={lang} tone="app" fullscreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (!owner) return <Navigate to="/admin2/dashboard" replace />;

  const name = (profile?.full_name || profile?.email || '').trim();
  const navItem = (s) => (
    <button key={s.slug} type="button" className={`gos-nav-item${active === s.slug ? ' on' : ''}`}
            aria-current={active === s.slug ? 'page' : undefined} onClick={() => nav(growthPath(s.slug))}>
      <Icon name={s.icon} />
      <span>{s.ar}</span>
      {s.slug === 'approvals' && pending > 0 && <span className="gos-pill bad" data-pending-badge={pending}>{pending}</span>}
    </button>
  );

  return (
    <div className="gos" dir="rtl" lang="ar">
      <div className="gos-shell">
        <div className={`gos-overlay${drawer ? ' open' : ''}`} onClick={() => setDrawer(false)} />
        <aside className={`gos-side${drawer ? ' open' : ''}`} aria-label="Growth OS">
          <div className="gos-brand">
            <div dir="ltr" style={{ display: 'flex', justifyContent: 'flex-end' }}><MaabarWordmark height={18} /></div>
            <p className="gos-brand-sub">GROWTH OS</p>
          </div>
          <button type="button" className="gos-back" onClick={() => nav('/admin2')}>
            <Icon name="back" size={15} />
            <span>رجوع للوحة الإدارة</span>
          </button>
          <div className="gos-nav" role="navigation" aria-label="أقسام Growth OS">
            {GROWTH_SECTIONS.filter((s) => s.group !== 'system').map(navItem)}
            <div className="gos-nav-sep" role="separator" />
            {GROWTH_SECTIONS.filter((s) => s.group === 'system').map(navItem)}
          </div>
          <div className="gos-int" data-growth-integrations="1">
            <h4>حالة التكاملات</h4>
            {(integrations || []).map((it) => (
              <div key={it.key} className="gos-int-row" data-integration={it.key} data-integration-state={it.state}>
                <span className={`gos-dot ${it.state}`} aria-hidden="true" />
                <b>{it.name}</b>
                <span className="gos-int-state">{it.label}</span>
              </div>
            ))}
            {!integrations && <div className="gos-int-row"><span className="gos-int-state">…</span></div>}
          </div>
        </aside>
        <div className="gos-main">
          <div className="gos-top" role="banner">
            <button type="button" className="gos-burger" onClick={() => setDrawer(true)} aria-label="القائمة"><Icon name="menu" size={20} /></button>
            <h1 className="gos-top-title">{title}</h1>
            {actions}
            {name && <span className="gos-avatar" title={name} aria-hidden="true">{name.charAt(0).toUpperCase()}</span>}
          </div>
          <div className="gos-content" role="main">{children}</div>
        </div>
      </div>
    </div>
  );
}
